export const FIND_PROCESS_STATEMENT_QUESTIONS_REQUEST = 'FIND_PROCESS_STATEMENT_QUESTIONS_REQUEST';

export const findProcessStatementQuestionsRequest = () => ({
    type: FIND_PROCESS_STATEMENT_QUESTIONS_REQUEST,
});
